import React from "react";
import { Skeleton } from "@mui/material";

const MessageLoader = () => {
  return (
    <>
      <div className="px-3 py-2 border-bottom">
        <Skeleton
          className="plan-c"
          variant="text"
          height={15}
          style={{ marginBottom: "5px" }}
        />
      </div>

      <div className="px-3 py-2 border-bottom">
        <Skeleton
          className="plan-c"
          variant="text"
          height={15}
          style={{ marginBottom: "5px" }}
        />
      </div>
    </>
  );
};

export default MessageLoader;
